import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'GroupSearchPipe', pure: false,
    standalone: false
})
export class GroupSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(group => {
        if (group.name || group.customName) {
          return group.name.search(searchText) !== -1 || group.customName.search(searchText) !== -1;
        }
      });
    }
  }
}